import './App.css';
import { BrowserRouter as Router, Route, Routes} from 'react-router-dom';
import Home from './Pages/Home';
import Content from './Pages/Content';
import { StatusProvider } from './Components/ContextApiStatus';
import { useState,useEffect } from 'react';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import Footer from './Components/Footer';
function App() {
  const [showScrollButton, setShowScrollButton] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      // Show the scroll-to-top button when the user scrolls down
      const shouldShow = window.scrollY > 600; // Adjust the scroll position as needed
      setShowScrollButton(shouldShow);
    };

    // Attach the scroll event listener
    window.addEventListener('scroll', handleScroll);

    // Remove the event listener when the component unmounts
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <StatusProvider>
    <div className="App">
      <Router>
        <Routes>
          <Route exact path="/" element={<Home />} />
          <Route path="/detail/:url" element={<Content index={0} />} />
        </Routes>
      </Router>
      {showScrollButton && (
        <div className="scroll-to-top" onClick={scrollToTop}>
          <KeyboardArrowUpIcon fontSize='50px' />
        </div>
      )}
    </div>
    <Footer />
    </StatusProvider>
  );
}

export default App;
